// src/seo.js

const SEO_DATA = {
  "/": {
    // title: "Peregrinee | #1 Global IT & Digital Transformation Agency",
    title: "#1 IT & Digital Transformation Company | Data Security Guaranteed | Peregrinee",
    description:
      "Empowering businesses globally with next-gen software, AI, and digital transformation solutions.",
  },
  "/custom-software-development": {
    title: "Custom Software Development | Peregrinee",
    description:
      "Build scalable and tailored software solutions with Peregrinee’s expert development team.",
  },
  "/artificial-intelligence": {
    title: "Artificial Intelligence Solutions | Peregrinee",
    description:
      "Leverage cutting-edge AI technology to automate, analyze, and grow your business.",
  },
  "/ai-agent-development": {
    title: "AI Agent Development | Peregrinee",
    description:
      "Create intelligent virtual agents for business automation, customer support, and productivity.",
  },
  "/minimum-viable-product": {
    title: "MVP Development Services | Peregrinee",
    description:
      "Launch your product fast with a market-ready Minimum Viable Product built by experts.",
  },
  "/website-and-app-development": {
    title: "Website & App Development | Peregrinee",
    description:
      "Get custom websites and mobile apps designed for performance, scale, and impact.",
  },
  "/product-development": {
    title: "Product Development Services | Peregrinee",
    description:
      "End-to-end product design and development services tailored to your business vision.",
  },
  "/enterprise-web-development": {
    title: "Enterprise Web Development | Peregrinee",
    description:
      "Secure, scalable, and powerful enterprise web solutions for digital-first organizations.",
  },
  "/blockchain-development": {
    title: "Blockchain Development Company | Peregrinee",
    description:
      "Transform your operations with secure and transparent blockchain-powered applications.",
  },
  "/case-studies": {
    title: "Client Case Studies | Peregrinee",
    description:
      "Explore success stories and digital transformations delivered by Peregrinee worldwide.",
  },
  "/client-testimonials": {
    title: "Client Testimonials | Peregrinee",
    description:
      "Hear from satisfied clients who’ve transformed their businesses with Peregrinee.",
  },
  "/contact-us": {
    title: "Contact Us | Peregrinee",
    description:
      "Ready to start your digital journey? Connect with the Peregrinee team today.",
  },
  "/thankyou": {
    title: "Thank You | Peregrinee",
    description:
      "Thank you for reaching out. Our team will get back to you shortly.",
  },
  "/services": {
    title: "Our Services | Peregrinee",
    description:
      "From AI to web and app development, explore Peregrinee’s full suite of IT services.",
  },
  "/healthcare": {
    title: "Healthcare IT Solutions | Peregrinee",
    description:
      "Revolutionize patient care and operational efficiency with our healthcare tech solutions.",
  },
  "/fintech": {
    title: "Fintech Software Solutions | Peregrinee",
    description:
      "Secure, scalable fintech apps and platforms for the future of digital finance.",
  },
  "/retail": {
    title: "Retail IT Services | Peregrinee",
    description:
      "Digitally transform your retail business with custom eCommerce and ERP solutions.",
  },
  "/entertainment-gaming": {
    title: "Entertainment & Gaming Solutions | Peregrinee",
    description:
      "Immersive, interactive digital products for media, streaming, and gaming brands.",
  },
  "/media-communications": {
    title: "Media & Communication Tech | Peregrinee",
    description:
      "Modern media and communication tools to keep your business connected and engaging.",
  },
  "/offshore-development": {
    title: "Offshore Development Services | Peregrinee",
    description:
      "Hire top global tech talent through our efficient offshore development solutions.",
  },
  "/hrias-by-peregrinee": {
    title: "HRIAS by Peregrinee",
    description:
      "Explore HRIAS – our smart Marketing automation solution for modern enterprises.",
  },
  "/coresync-erp": {
    title: "CoreSync ERP by Peregrinee",
    description:
      "Streamline business operations with our comprehensive CoreSync ERP platform.",
  },
  "/play-mind": {
    title: "PlayMind App by Peregrinee",
    description:
      "Discover PlayMind – a mental wellness and productivity app developed by Peregrinee.",
  },
  "/uxgenie": {
    title: "UXGenie by Peregrinee",
    description:
      "Boost UX research and design workflow with our powerful UXGenie platform.",
  },
  "/retailnova": {
    title: "RetailNova by Peregrinee",
    description:
      "Empower your retail business with RetailNova – an all-in-one digital retail solution.",
  },
  "/finsightx": {
    title: "FinSightX by Peregrinee",
    description:
      "Smart analytics and insights for financial organizations using FinSightX.",
  },
  "/gamergrid": {
    title: "GamerGrid by Peregrinee",
    description:
      "A connected platform for gamers – tournaments, community, and streaming made easy.",
  },
  "/medicore-erp": {
    title: "MediCore ERP by Peregrinee",
    description:
      "Simplify healthcare and clinic management with MediCore ERP’s robust features.",
  },
  "/edumind": {
    title: "EduMind LMS by Peregrinee",
    description:
      "A smart learning management system to elevate education delivery and tracking.",
  },
  "/remente": {
    title: "Remente App by Peregrinee",
    description:
      "Enhance personal development and mental health with Remente, powered by Peregrinee.",
  },
};

export default SEO_DATA;
